import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  // maxWidth: (p) => p.spacing(35),
};

export const firstCard: SxStyle = {
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(1, 1, 0, 0),
  borderBottom: 'none',
  boxShadow: '0px 7px 18px rgba(0, 0, 0, 0.06)',
};

export const secondCard: SxStyle = {
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(0, 0, 1, 1),
  borderTopColor: (p) => p.palette.grey[200],
  boxShadow: '0px 7px 18px rgba(0, 0, 0, 0.06)',
};

export const card: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(2),
  padding: (p) => p.spacing(1),
  height: (p) => p.spacing(22),
  boxShadow: 'none',
  borderColor: (p) => p.palette.grey[200],
};

export const iconCard: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'none',
  width: (p) => p.spacing(3.5),
  height: (p) => p.spacing(3.5),
  borderRadius: (p) => p.spacing(0.5),
  border: (p) => `0.75px solid ${p.palette.primary[100]}`,
  backgroundColor: '#FFF',
  backgroundImage:
    'linear-gradient(321deg, rgba(24, 81, 239, 0.00) 35.83%, rgba(24, 81, 239, 0.20) 98.96%)',
};

export const name: SxStyle = {
  fontSize: (p) => p.typography.body3.fontSize,
  fontWeight: (p) => p.typography.fontWeightRegular,
  color: (p) => p.palette.grey[500],
  minWidth: 0,
  flex: 1,
};
